import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const BulkUpdateBasicLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'BulkUpdateBasic' */ './components/BulkUpdateBasic'
		)
);

export default (store) => {
	return {
		path: 'students-setup/:campusId?/bulk-update-basic',
		element: (
			<AsyncLoading
				component={<BulkUpdateBasicLazy permission="CanManageAdmissionSetup" />}
			/>
		),
	};
};
